import { getAuth } from 'firebase/auth';

export const getFirebaseAuthToken = async (currentUser = null) => {
  if (currentUser) {
    return currentUser.getIdToken(true);
  }

  const auth = getAuth();
  if (auth.currentUser) {
    return auth.currentUser.getIdToken(true);
  }

  throw new Error('You must be logged in to perform this action.');
};
